<template>
	<transition name="modal">
		<div class="modal-mask" :class="modalId" @click="close" ref="modal">
			<div class="modal-container" @click.stop>
				<div class="banner display-2" v-if="$slots.banner">
					<slot name="banner"></slot>
				</div>
				<div class="header display-2" v-if="$slots.header">
					<slot name="header"></slot>
				</div>
				<div class="subHeader body-2" v-if="$slots.subHeader">
					<slot name="subHeader"></slot>
				</div>
				<div class="content body-2">
					<slot></slot>
				</div>
				<div class="footer" v-if="$slots.footer">
					<slot name="footer"></slot>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'Modal',
	props: ['modalOpen', 'modalId'],
	created() {
		window.addEventListener('keyup', this.onKeyup);
	},
	watch: {
		modalOpen() {
			if (this.modalOpen && this.hasInput) this.hasInput.focus();
		},
	},
	computed: {
		hasInput() {
			return document.querySelector('.modal-container .input:first-of-type');
		},
	},
	methods: {
		close() {
			this.$nextTick(() => {
				this.$emit('close');
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.modal-mask {
	position: fixed;
	z-index: 999999;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	@include flexRow;
	justify-content: center;
	align-items: center;
	background-color: rgba(0, 0, 0, 0.5);
	transition: opacity 0.3s ease;
	padding: 0 16px;
	.modal-container {
		min-width: 320px;
		width: 100%;
		max-width: 600px;
		min-height: 350px;
		max-height: 90vh;
		overflow: auto;
		@include flexColumn;
		margin: 0 auto;
		padding: 32px 24px;
		background-color: $white;
		border-radius: 4px;
		box-shadow: 0 16px 24px rgba(8, 35, 48, 0.16);
		transition: all 0.3s ease;

		.banner {
			background: $color-super-light-blue;
			border-radius: 4px 4px 0px 0px;
			height: 180px;
			margin-bottom: 24px;

			@media (max-width: $mobile) {
				height: 120px;
				margin-bottom: 14px;
			}
		}
		.header {
			padding-bottom: 23px;
			
		}
		.display-2 {
			@media (max-width: $mobile) {
				padding-bottom: 8px;
				font-size: 1.25rem;
			}
		}
		.subHeader {
			margin-bottom: 25px;
			
		}
		.body-2 {
			@media (max-width: $mobile) {
				margin-bottom: 8px;
				font-size: 1rem;
			}
		}
		.content {
			flex: 1;
			margin-bottom: 16px;
			@media (max-width: $mobile) {
				overflow:hidden;
			}
		}
		.footer {
			@include flexRow;
			div {
				border: 1px solid red !important;
				@include flexRow;
			}
		}
	}
	&.preLoginModal {
		.modal-container {
			padding: 0 0 24px 0;
			min-width: 500px;
			width: 500px;

			@media (max-width: $mobile) {
				min-width: 328px;
				width: 328px;
			}

			.header,
			.content,
			.footer {
				padding: 0 32px;

				@media (max-width: $mobile) {
					padding: 0 16px;
				}
			}
			.header {
				padding-bottom: 0;
				margin-bottom: 16px;
			}
			.content {
				margin-bottom: 32px;
			}
			.footer {
				@include flexColumn;
				align-items: flex-start;
			}
		}
	}
}
.modal-enter {
	opacity: 0;
}

.modal-leave-active {
	opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}
</style>
